import { twMerge } from "tailwind-merge"

const DesktopOnly = ({ className = "", children, ...rest }) => {
  return (
    <div className={twMerge("hidden md:block", className)} {...rest}>
      {children}
    </div>
  )
}

export default DesktopOnly
